// extracted by mini-css-extract-plugin
export default {"modal":"FilterPasteModal_modal__pHCum","footer":"FilterPasteModal_footer__ZijqQ"};